import { render, staticRenderFns } from "./wholeOrderAfterSale.vue?vue&type=template&id=c146ab64&scoped=true&"
import script from "./wholeOrderAfterSale.vue?vue&type=script&lang=js&"
export * from "./wholeOrderAfterSale.vue?vue&type=script&lang=js&"
import style0 from "./wholeOrderAfterSale.vue?vue&type=style&index=0&id=c146ab64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c146ab64",
  null
  
)

export default component.exports